import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { scrollElementIntoView } from '~/utils/dom';

export default function ScrollToError() {
	const formik = useFormikContext();
	const submitting = formik?.isSubmitting;

	useEffect(() => {
		const go = () => {
			scrollElementIntoView(document.querySelector('.input-error'));
		};

		setTimeout(go, 100);
	}, [submitting]);

	return null;
}
